import { DefaultResetPasswordComponent } from './components/reset-password/templates/default/default-reset-password.component';
import { DefaultLoginComponent } from "./components/login/templates/default/default-login.component";
import { SocialLoginComponent } from "./components/login/templates/social/social-login.component";
import { DefaultRegisterComponent } from './components/register/templates/default/default-register.component';
import { SocialRegisterComponent } from './components/register/templates/social/social-register.component';
import { SocialForgotPasswordComponent } from './components/forgot-password/templates/social/social-forgot-password.component';
import { DefaultForgotPasswordComponent } from './components/forgot-password/templates/default/default-forgot-password.component';
import { SocialResetPasswordComponent } from './components/reset-password/templates/social/social-reset-password.component';
import { CieloLoginComponent } from './components/login/templates/cielo/cielo-login.component';
import { CieloRegisterComponent } from './components/register/templates/cielo/cielo-register.component';
import { CieloForgotPasswordComponent } from './components/forgot-password/templates/cielo/cielo-forgot-password.component';

export const authComponentDef = {
    "login": {
        "default": DefaultLoginComponent,
        "social": SocialLoginComponent,
        "cielo": CieloLoginComponent
    },
    "register": {
        "default": DefaultRegisterComponent,
        "social": SocialRegisterComponent,
        "cielo": CieloRegisterComponent
    },
    "forgot-password": {
        "default": DefaultForgotPasswordComponent,
        "social": SocialForgotPasswordComponent,
        "cielo": CieloForgotPasswordComponent
    },
    "reset-password": {
        "default": DefaultResetPasswordComponent,
        "social": SocialResetPasswordComponent,
        "cielo": DefaultResetPasswordComponent
    }
}